const supplierLayout = {
    quotation: "가격 조회서",
    pendingQuotation: "쿼트 대기",
    resolveQuotation: "쿼트됨",
    other: "기타",
    purchaseOrder: "주문",

    login: '로그인',
    loginTitle: 'WMS 로그인',
    acntNotExist: '계정이 존재하지 않습니다확인하세요',
    acntNotAvailable: '계정이 이미 존재하거나 비활성화되었습니다',
    loginFail: ' 로그인 실패',
    updatePwd: ' 암호 수정',
    pwd: '암호',
    inputPwd: '암호를 입력하십시오',
    inputAct: '계정을 입력하십시오',
    inputPwdSec: '암호를 다시 입력하십시오',
    confirmPwd: "비밀번호 확인",
    logOut: '로그인 종료',
    logOutTipTitle: "로그인을 종료하시겠습니까?",
    logOutTipContent: "확인 종료 후 로그인 페이지로 돌아갑니다.",
    confirmTip: "이번 문의 견적을 거절하시겠습니까?",
    confirmTip2: "견적 후, 구매자는 당신의 견적을 받을 것이며, 당신의 견적을 받아들이거나 거절할 수 있습니다.",
    pwdError: '암호 수정 실패',
    editPwd: '암호 수정',
    searchByKeyword: "키워드 검색 입력",
    accountErr: "잘못된 계정 또는 암호",
    deliveryNotice: '배송 알림',
    business: '비즈니스',
    reconciliation:'체크',
    contract:'계약 관리',
    quotations:'견적',
    proQuotations:'상품 견적',
    myQuotations:'내 오퍼',
};

export default supplierLayout;